Object.defineProperty(exports, "__esModule", {
  value: true,
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.httpGetMethod = "GET";

exports.ApiUrls = {
  storesList: "bx_block_store_locator/stores",
};

exports.Strings = {
  pageTitle: "Stores",
  noRecordFounds: "No Stores Found",
};

exports.daysOfWeek = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];
// Customizable Area End
